import { mapGetters } from "vuex";

export default {
    name: "CosmoBaseExperts",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
        ...mapGetters({
            content: "cosmobase/content",
        }),
    },
    methods: {}
}
